const newsletterForm = <HTMLFormElement>document.getElementById("subscribe-form");

if (newsletterForm) {
    const submitButton = newsletterForm.querySelector(".subscribe-button");
    const responseContainer = document.getElementById("newsletter-subscribe-response");
    const successContainer = responseContainer.querySelector<HTMLElement>(".success");
    const errorContainer = responseContainer.querySelector<HTMLElement>(".error");
    newsletterForm.addEventListener("submit", async (e: SubmitEvent) => {
        submitButton.classList.add("loading");
        e.preventDefault();
        if (newsletterForm.checkValidity()) {
            const formData = new FormData(newsletterForm);
            const response = await fetch("/actions/campaign/forms/subscribe", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                },
                body: formData,
            });
            submitButton.classList.remove("loading");
            const result = await response.json();
            responseContainer.classList.add("visible");
            if (response.ok && response.status === 200) {
                newsletterForm.classList.add("hidden");
                successContainer.innerText = result.message;
                errorContainer.innerText = "";
            } else {
                successContainer.innerText = "";
                try {
                    errorContainer.innerText = String(Object.values(result.errors).pop());
                } catch {
                    errorContainer.innerText = result.message;
                }
            }
        } else {
            newsletterForm.reportValidity();
        }
    });
}
